import React from 'react';
import { handlePhoneCall } from './checkMobileWebView';

/**
 * Converts text containing phone numbers into JSX elements with clickable phone links
 * Phone numbers are detected using regex pattern and converted to tel: links with proper styling
 * @param text - The text that may contain phone numbers
 * @returns JSX element with clickable phone links
 */
export const formatTextWithPhoneNumbers = (text: string): JSX.Element => {
  // Regex to match phone numbers like "024 2229 8888", "(+84) 24 2229 8888", etc.
  const phoneRegex = /(\(?\+?84\)?\s?0?24\s?2229\s?8888|024\s?2229\s?8888)/gi;

  const parts = text.split(phoneRegex);

  return (
    <>
      {parts.map((part, index) => {
        // Create new regex instance to avoid global flag issues
        const testRegex = /(\(?\+?84\)?\s?0?24\s?2229\s?8888|024\s?2229\s?8888)/i;

        // Check if this part is a phone number
        if (testRegex.test(part)) {
          const cleanPhoneNumber = part.replace(/\s+/g, ' ').trim();
          return (
            <a
              key={index}
              href={`tel:${cleanPhoneNumber}`}
              style={{
                color: '#DD0071',
                textDecoration: 'none',
                fontWeight: 'inherit'
              }}
              onClick={(e) => {
                e.preventDefault();
                handlePhoneCall(cleanPhoneNumber);
              }}
            >
              {cleanPhoneNumber}
            </a>
          );
        }

        // Return regular text
        return <span key={index}>{part}</span>;
      })}
    </>
  );
};

/**
 * Alternative function that returns a string with JSX for use in dangerouslySetInnerHTML
 * @param text - The text that may contain phone numbers
 * @returns HTML string with clickable phone links
 */
export const formatTextWithPhoneNumbersAsHTML = (text: string): string => {
  const phoneRegex = /(\(?\+?84\)?\s?0?24\s?2229\s?8888|024\s?2229\s?8888)/gi;

  return text.replace(phoneRegex, (match) => {
    const cleanPhoneNumber = match.replace(/\s+/g, ' ').trim();
    return `<a href="tel:${cleanPhoneNumber}" style="color: #DD0071; text-decoration: none; font-weight: inherit;" onclick="event.preventDefault(); handlePhoneCall('${cleanPhoneNumber}')">${cleanPhoneNumber}</a>`;
  });
};


